export default {"src":"/_next/static/media/app_store.2fbaa4cd.svg","height":63,"width":202,"blurWidth":0,"blurHeight":0};